/* eslint-disable */

let googleAdsInitialized = false;

export function initGoogleAds() {
  if (googleAdsInitialized) return;

  const hostname = window.location.hostname;
  const isProd = hostname === 'webapp.everydoggy.com' || hostname === 'app.everydoggy.com';

  if (!isProd) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-16857709798';
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }

  window.gtag = window.gtag || gtag;

  window.gtag('js', new Date());
  window.gtag('config', 'AW-16857709798', {
    send_page_view: true,
  });

  googleAdsInitialized = true;
}
